import { IAppState } from '../../../AppModulesWrapper';

import { EPlacingType } from '../../types/reducers/publishTerms';

export function selectActivePlacingType(state: IAppState): EPlacingType | null {
  return state.servicePickerWidget.publishTerms.selectedPlacingType;
}
